export default "\n<mat-spinner></mat-spinner>\n";